export default "__VITE_ASSET__Dw0OEYH9__"